import {ECompanyStatus} from '@app/constants';
import {useAppSelector} from '@app/redux/reduxHooks';
import {userSelector} from '@app/redux/slices/userSlice';

export const useIsDemo = () => {
  const companyStatus = useAppSelector(userSelector)?.company?.status;
  return companyStatus === ECompanyStatus.DEMO;
};
